import Vue from "vue";

const apiRoutes = {
    auth: {
        login: {
            name: "Login",
            url: "/auth/token/login",
            method: "post",
        },

        user: {
            name: "get_user",
            url: "/auth/users/me/",
        },
        createPassword: {
            url: "/activate",
        },
    },
    users: {
        name: "register_user",
        url: "users",
        updateuser: "users/update/",
    },
    roles: {
        getRoles: "get-roles",
        addRoles: "add-roles",
        deleteRole: "remove-roles",
        getRoleById: "get-role-by-id",
        updateRole: 'update-role'
    },
    permissions:{
        update: 'update-permission',
        getPermission: 'get-permissions'
    },
    subject: {
        url: "/subjects",
    },
    classes: {
        url: "/classes",
        all: "/classes/all",
    },
    TutorCv: {
        url: "/tutor-cv",
        update: "/tutor-cv-update",
    },
    AddCallData: {
        url: "/call-data",
    },
    JoinedTutors: {
        url: "/joined-tutors",
    },
    tutors: {
        url: "/tutors",
        tutorpanel: {
            profile: "tutorpanel/profile",
        },
    },
    groups: {
        url: "/groups",
        details: "/group/details/",
        addStudents: "/group/addStudents/",
        create: "/group/create/new",
    },
    countries: {
        url: "/countries",
        byCountry: "get/states/",
    },
    cities: {
        url: "/cities-by-country/",
        byCountry: "get/cities/",
    },
    cities: {
        url: "/cities-by-country/",
        byCountry: "get/cities/",
    },
    students: {
        url: "/students",
        joinedUrl: "/joined/students",
        bookAssessment: "/book-assessment",
        updateJoinedUrl: "/joined/students/update",
        assessmentRecordUrl: "/students/assessments/record",
        assessmentUrl: "/students/assessments",
        joinUrl: "/students/from/assessment/",
        addToGroup: "/students/ ",
        catchups: "/students/catchups",
        works: "/students/works",
        classes: "/students/classes",
        studentpanel: {
            profile: "/studentpanel/profile",
        },
    },
    reports: {
        getReport: "/reports/attendance",
        getStudentList: '/get-student-list',
        getTutorList: '/get-tutor-list'
    },
    sessions: {
        addToGroup: "sessions/add/group/",
        reschedule: "sessions/reschedule/",
    },
    discounts: {
        url: "/discounts",
    },
    WorkSheet: {
        downloadworkSheet: "/download-workSheet/",
        assignedWorkSheetOfStudent: "/student-workSheet",
        assignedWorkSheet: "/assigned-workSheet",
        assign: "/assign-workSheet",
        url: "/work-sheet",
        get: "/work-sheet-get",
        del: "/delete-work-sheet",
        getWorkSheet: "/get-work-sheet",
        getStudent: "/get-student",
        chartWorkSheet: "/get-chart-work-sheet",
        answerSheet: "/answer-sheet-get"
    },

    subjects: {
        url: "/get-subject",
    },
    work: {
        url: "/works",
        fileDelete: "/works/file/destroy/",
        studentwork: "works/student/",
    },
    attendance: {
        catchups: "/catchups",
        requests: "/requests",
        complete: "/complete",
        mark_attendance: "/markAttendance/",
        absent: "/absent",
    },
    AdmissionForm: {
        url: "/admission-form",
        edit: "/admission-form/edit",
        update: "/admission-form/update",
        check: "/admission-form/check",
    },
    UploadWork: {
        uploadwork: "/upload-work/upload",
        url: "/upload-work/get-tutor",
        getData: "/upload-work/get-previousData",
        getStudentData: "/upload-work/get-previousStudentData",
        studentOfTutor: "/uploaded-work/student",
        status: "/uploaded-work/status",
        checked: "/uploaded-work/checked",
        uploadByTutor: "/upload-work/upload/tutor",

    },
    accounts: {
        invoices: {
            students: {
                getStudentInvoice: "/accounts/invoice/getStudentInvoice",
                url: "/accounts/invoices/students",
                create: "/accounts/invoices/students/create",
                edit: "/accounts/invoices/students/edit/",
                store: "/accounts/invoices/students/store",
                status: "/accounts/invoices/students/update/status/",
                delete: "/accounts/invoices/students/remove",
            },
            tutors: {
                url: "/accounts/invoices/tutors",
                delete: "/accounts/invoices/destroy",
                getInvoice: "/accounts/invoices-detail",
                fetch: "/accounts/invoices/tutors/fetch-detail",
                store: "/accounts/invoices/tutors/store",
            },
        },
    },
};

// Plugin.install = function (Vue, options) {
//     Vue.apiRoutes = _apiRoutes;
//     window.apiRoutes = _apiRoutes;
// };
//
// Vue.use(Plugin)

export default apiRoutes;